<template>
  <!--
  1.默认寄件地址

 -->
  <PageMain class="app-container send-page ">
    <div class="pl-20 pr-20 pb-20  bg-w">

      <a-form-model ref="form" layout="inline" :model="form" :rules="rules">

        <!-- 寄件人信息 -->
        <div class="h-46 flex a-center flex-j-sb bg-blue1 pr-16 pl-16 ">
          <div class="mr-36"><span class="text-icon-r mr-5">1</span><span class="f-c-b1 fs-b">寄件人</span></div>
          <div class="flex">
            <div class="mr-36 f-c-blue pointer" @click="visible1 = true">选择寄件人</div>
            <div class="f-c-blue pointer" @click="getAddr1">智能识别地址</div>
          </div>
        </div>
        <div class="flex mb-2 mt-16 pl-30">
          <a-form-model-item class="my-form-item  " prop="sname">
            <span slot="label">姓　　名</span>
            <a-input
              v-model="form.sname"
              class="w-280"
              placeholder="请输入寄件人的姓名"
            />
          </a-form-model-item>
          <a-form-model-item class="my-form-item my-pl-20" prop="sphone">
            <span slot="label" class="">联系方式</span>
            <a-input
              v-model="form.sphone"
              class="w-280"
              placeholder="填写手机号或者固定电话"
            />
          </a-form-model-item>
          <a-form-model-item class="my-form-item my-pl-20" prop="scompany">
            <span slot="label" class="">公　　司</span>
            <a-input
              v-model="form.scompany"
              class="w-280"
              placeholder="请输入寄件人所在的公司"
            />
          </a-form-model-item>
        </div>
        <div class="flex pl-30 pr-14 a-center">
          <a-form-model-item class="my-form-item flex1 " prop="saddr">
            <span slot="label">寄件地址</span>
            <Addr :result.sync="form.saddr" class="mt-4 addr" />
          </a-form-model-item>
          <a-checkbox v-model="isSetDefaultAddr" class="">
            添加到地址库
          </a-checkbox>

        </div>

        <!-- 收件人信息 -->
        <div class="h-46 flex a-center flex-j-sb bg-blue1 pr-16 pl-16 mt-16">
          <div class="mr-36"><span class="text-icon-r mr-5">2</span><span class="f-c-b1 fs-b">收件人</span></div>
          <div class="flex">

            <div class="mr-36 f-c-blue pointer" @click="visible2 = true">选择收件人</div>
            <div class="f-c-blue pointer" @click="getAddr2">智能识别地址</div>
          </div>
        </div>
        <div class="pl-30 flex mb-2 mt-16">
          <a-form-model-item class="my-form-item  " prop="rname">
            <span slot="label">姓　　名</span>
            <a-input
              v-model="form.rname"
              class="w-280"
              placeholder="请输入收件人的姓名"
            />
          </a-form-model-item>
          <a-form-model-item class="my-form-item my-pl-20" prop="rphone">
            <span slot="label" class="">联系方式</span>
            <a-input
              v-model="form.rphone"
              class="w-280"
              placeholder="填写手机号或者固定电话"
            />
          </a-form-model-item>
          <a-form-model-item class="my-form-item my-pl-20" prop="rcompany">
            <span slot="label" class="">公　　司</span>
            <a-input
              v-model="form.rcompany"
              class="w-280"
              placeholder="请输入收件人所在的公司"
            />
          </a-form-model-item>
        </div>
        <div class="flex pl-30">
          <a-form-model-item class="my-form-item flex2" prop="raddr">
            <span slot="label">收件地址</span>
            <Addr :result.sync="form.raddr" class="mt-4 addr" />
          </a-form-model-item>
          <a-form-model-item class="my-form-item my-pl-20 flex1" />
        </div>

        <!-- 包裹信息 -->
        <div class="h-46 fs-14 flex a-center bg-blue1 pr-16 pl-16 mt-16">
          <div class="mr-36"><span class="text-icon-r mr-5">3</span><span class="f-c-b1 fs-b">快递及包裹信息</span></div>
        </div>

        <!-- <div class="flex pl-30 mt-20">
          <a-form-model-item class="my-form-item  " prop="shipperCode">
            <span slot="label">选择快递</span>
            <div class="flex ">
              <div v-for="(i,index) in companys" :key="i.name" class="company mr-10" :class="sIndex === index?'c-active':''" @click="sIndex = index">
                <img v-if="icoMap[i.shippercode]" style="vertical-align: text-top;" class="w-20" :src="icoMap[i.shippercode]" alt="">
                <span>{{ i.shippername }}</span>
              </div>
            </div>
          </a-form-model-item>
        </div> -->

        <!-- <div class="flex pl-30 mt-20">
          <a-form-model-item class="my-form-item  " prop="payType">
            <span slot="label">结算方式</span>
            <div class="flex ">
              <a-select v-model="form.payType" :disabled="!payTypes" placeholder="请选择结算方式" class="w-400">
                <a-select-option v-if="payTypes&&+payTypes.enablemonth" :value="3">
                  月结支付 {{ payTypes.monthcode ?'月结编号：'+payTypes.monthcode:'' }}
                </a-select-option>
                <a-select-option v-if="payTypes&&+payTypes.enableprepayment" :value="5">
                  预充支付
                </a-select-option>
                <a-select-option v-if="payTypes&&+payTypes.enableselfsettle" :value="1">
                  线下结算
                </a-select-option>
              </a-select>
            </div>
          </a-form-model-item>
        </div> -->

        <div class="flex  mt-10 pl-30">
          <a-form-model-item class="my-form-item  " prop="pickTime">
            <span slot="label">上门时间</span>
            <div class="flex pt-4">
              <a-select v-model="form.pickDay" class="w-140">
                <a-select-option :key="-1" :value="''">
                  请选择预约日
                </a-select-option>
                <a-select-option v-for="(i,index) in dayOpts" :key="index" :value="i.code">
                  {{ i.name }}
                </a-select-option>
              </a-select>
              <a-select v-model="form.pickTime" class="w-140">
                <a-select-option :key="-1" :value="''">
                  请选择预约时间
                </a-select-option>
                <a-select-option v-for="(i,index) in timeOpts" :key="index" :value="i.code">
                  {{ i.name }}
                </a-select-option>
              </a-select>
              <a-tooltip>
                <template slot="title">
                  支持72小时以内的预约
                </template>
                <div class="yiwen"><a-icon type="question-circle" /></div>
              </a-tooltip>
            </div>
          </a-form-model-item>
          <a-form-model-item class="my-form-item  pl-30">
            <span slot="label">预估重量</span>

            <a-input v-model="form.weight" class="w-280" type="number" suffix="KG" />

          </a-form-model-item>
          <a-form-model-item class="my-form-item  " />
        </div>

        <div class="flex h-32 mt-10 pl-30">
          <a-form-model-item class="my-form-item " prop="cargos">
            <span slot="label">物品类型</span>
            <div class="flex a-center">
              <div v-for="(i,index) in goods" :key="i.name" class="goods mr-10" :class="gIndex === index?'c-active':''" @click="gIndex = index">
                {{ i.name }}
              </div>
            </div>
          </a-form-model-item>
        </div>
        <div class="flex h-32 mt-10 pl-40">
          <a-form-model-item class="my-form-item ">
            <span slot="label">备　　注</span>
            <a-input v-model="form.remark" class="w-280" />
          </a-form-model-item>
        </div>
        <div class="v-line" />
        <div class="flex pl-30 mt-20">
          <a-form-model-item class="my-form-item w-100p shipperSelect  " prop="payType">
            <!-- <span slot="label">选择快递</span> -->
            <a-table class="w-100p" :columns="shipperListTable" :data-source="companys" :pagination="false">
              <div slot="customTitle1" class="req"><span class="mr-4" style="color:#f5222d;font-size:14px">*</span>选择快递</div>
              <div slot="customTitle2" class="req"><span class="mr-4" style="color:#f5222d;font-size:14px">*</span>选择支付方式</div>
              <div slot="customTitle3">预估运费</div>
              <div slot="c1" slot-scope="i" class="flex a-center">
                <img class="w-24" :src="icoMap[i.shippercode||i.shipperCode]" alt="">
                <div class="ml-10">
                  <div class="fs-b">{{ i.shippername }}</div>
                  <div>{{ i.estimate }}</div>
                </div>
              </div>
              <div slot="c2" slot-scope="text, i, index" class="flex a-center">
                <a-radio-group v-model="form.payType">
                  <a-radio v-if="i&&+i.enableprepayment" :value="(i.shippercode||i.shipperCode)+'-'+5">
                    预充支付
                  </a-radio>
                  <a-radio v-if="i&&+i.enablemonth" :value="(i.shippercode||i.shipperCode)+'-'+3">
                    <span>自有月结 {{ i.monthcode?'('+i.monthcode+')':'' }}</span>
                  </a-radio>
                  <a-radio v-if="i&&+i.enableselfsettle" :value="(i.shippercode||i.shipperCode)+'-'+1">
                    线下结算
                  </a-radio>
                </a-radio-group>
              </div>
              <div slot="c3" slot-scope="i" class="flex a-center">
                <div v-if="i.estimatePrice && form.payType!==((i.shippercode||i.shipperCode)+'-'+1)" class="f-c-red">¥{{ Number(i.estimatePrice).toFixed(2) }}</div>
                <div v-else class="f-c-red">¥ -.--</div>
              </div>
            </a-table>
          </a-form-model-item>
        </div>
        <div v-if="form.payType&&(+form.payType.split('-')[1] === 5)&&coupon&&coupon.usableAmount>0" style="background:#ffffba" class="fs-18 mt-20 t-center pd-10">
          本单可使用 <span class="f-c-red">￥ {{ coupon&&coupon.usableAmount }}</span>优惠券
        </div>
        <div class="pd-20 bg-blue1  mt-10">
          <div>当前选择：{{ cCompany&&cCompany.shippername || '--' }}，预估运费：
            <span class="f-c-red fs-18">￥{{ cCompany&&cCompany.estimatePrice?$utils.Big(cCompany.estimatePrice).minus(coupon&&coupon.usableAmount):'--' }}</span>
            <span v-if="coupon&&coupon.usableAmount>0" style="text-decoration: line-through;">￥{{ cCompany&&cCompany.estimatePrice }}</span>
            （按输入物品重量<span class="f-c-blue pointer" @click="checkFreight">预估运费</span>）
          </div>
          <div>
            <div class="">
              <a-form-model-item class="my-form-item " prop="agree">
                <a-checkbox v-model="form.agree">
                  <span>我已阅读并同意</span>
                </a-checkbox>
                <span class="f-c-blue pointer" @click.stop="aviz = true">《快递鸟企业寄件服务条款》</span>
              </a-form-model-item>
            </div>
            <a-button class="w-300 mt-10" type="primary" :loading="loading" @click.native="post">立即下单</a-button>
          </div>
        </div>
      </a-form-model>
    </div>
    <AddrList :key="1" :address-type="1" :visible.sync="visible1" @ok="ok1" />
    <AddrList :key="2" :address-type="2" :visible.sync="visible2" @ok="ok2" />
    <a-modal
      title="智能识别"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="getAddrInfo"
      @cancel="visible = false"
    >
      <div> <a-textarea
        v-model="addrInfo"
        placeholder="例如：张三，13800138000，广东省深圳市福田区保税区金花路29号华宝一号大厦A601"
        :auto-size="{ minRows: 3, maxRows: 5 }"
      /></div>
    </a-modal>

    <a-modal
      title="设置月结账号"
      :visible="showMonthCode"
      :width="480"
      @ok="setMonthCode"
      @cancel="showMonthCode = false"
    >
      <div>
        <div class="flex a-center"><div class="w-150">快递公司：</div><a-input :disabled="true" :value="cCompany&&cCompany.shippername" /></div>
        <div class="flex a-center mt-10"><div class="w-150">网点月结账号：</div><a-input v-model="mcode" placeholder="请输入月结账号" /></div>
        <div class="mt-10 fs-12 f-c-b2">说明：1、月结账号是快递网点给您开通的月结账号和密钥，具体咨询合作的快递员或者快递网点即可。2、寄快递选择“原有月结结算”属于线下结算。
        </div>
      </div>
    </a-modal>
    <Agreement :viz.sync="aviz" />
  </PageMain>
</template>
<script>

import Addr from '@/components/addr'
import Agreement from '@/components/agreement'

import AddrList from '@/components/addrList'
import validate from '@framework/utils/biz-validate'
import icoMap from '@/common/icoMap'
import moment from 'moment'
// addressRecognizeAddress
const shipperListTable = [
  { key: '', scopedSlots: { customRender: 'c1' }, slots: { title: 'customTitle1' }},
  { key: '', scopedSlots: { customRender: 'c2' }, slots: { title: 'customTitle2' }},
  { key: '', scopedSlots: { customRender: 'c3' }, slots: { title: 'customTitle3' }}
]
export default {
  name: 'Send',
  components: {
    Addr, AddrList, Agreement
  },
  props: {
    orderType: {
      type: Number,
      default: 1
    }
  },
  data() {
    // data函数返回的对象是具有双向绑定的数据，更新data里面的数据，可以触发ui的变化
    const validateMobile = (rule, value, callback) => {
      if (!this.$utils.rules.mobileOrPhone.pattern.test(value)) {
        callback(new Error(this.$utils.rules.mobileOrPhone.msg))
      } else {
        callback()
      }
    }
    const validateAddr = (rule, value, callback) => {
      if (!value || !value.provinceCode) {
        callback(new Error('请选择省市区'))
      } else if (!value || !value.addressDetail) {
        callback(new Error('请填写详细地址'))
      } else {
        callback()
      }
    }
    const validateCargos = (rule, value, callback) => {
      if (value.length < 1) {
        callback(new Error('请选择物品类型'))
      } else {
        callback()
      }
    }
    const validateAgree = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请同意《快递鸟企业寄件服务条款》'))
      } else {
        callback()
      }
    }
    return {
      mcode: '',
      showMonthCode: false,
      isSetDefaultAddr: false,
      shipperListTable,
      depname: '',
      aviz: false,
      payTypes: null,
      departmentList: [],
      recType: 0,
      confirmLoading: false,
      loading: false,
      icoMap,
      addrInfo: '',
      visible: false,
      visible1: false,
      visible2: false,
      moment,
      test: 0,
      rules: {
        payType: [{ required: true, trigger: 'change', message: '请选择快递公司和支付方式' }],
        // orderType: [{ required: true, trigger: 'change' }],
        sname: [{ required: true, trigger: 'change', message: '请输入寄件人的姓名' }],
        sphone: [{ required: true, trigger: 'change', validator: validateMobile }],
        saddr: [{ required: true, trigger: 'change', validator: validateAddr }],
        // scompany: [{ required: true, trigger: 'change', message: '请输入寄件人所在的公司' }],
        rname: [{ required: true, trigger: 'change', message: '请输入收件人的姓名' }],
        rphone: [{ required: true, trigger: 'change', validator: validateMobile }],
        raddr: [{ required: true, trigger: 'change', validator: validateAddr }],
        // rcompany: [{ required: true, trigger: 'change', message: '请输入收件人所在的公司' }],
        // shipperCode: [{ required: true, trigger: 'change', message: '请选择快递公司和支付方式' }],
        cargos: [{ required: true, trigger: 'change', validator: validateCargos }],
        agree: [{ required: true, trigger: 'change', validator: validateAgree }],
        pickTime: [{ required: true, trigger: 'change', message: '选择预约取件时间' }]

      },
      // sIndex: '',
      gIndex: 0,
      coupon: null,
      companys: [
      ],
      goods: [{ name: '文件' }, { name: '电子产品' }, { name: '日用品' }, { name: '服装鞋帽' }, { name: '食品' }, { name: '其他' }],
      defPickTime: '',
      form: {
        payType: undefined,
        departmentId: undefined,
        sname: '',
        sphone: '',
        stelephone: '',
        spca: '',
        saddr: null,
        scompany: '',
        // orderType: 1,
        rname: '',
        rphone: '',
        rtelephone: '',
        rpca: '',
        raddr: null,
        rcompany: '',
        shipperCode: '',
        // expCompany: '',
        // pickupEndTime: '2020-05-29 16:00:00',
        // pickupStartTime: '2020-05-29 14:00:00',
        weight: 1,
        pickTime: '',
        pickDay: '',
        cargos: [
          { name: '文件' }
        ],
        remark: '',
        agree: true
      },
      estimateTimePrice: null,
      dayOpts: [],
      timeOpts: []

    }
  },
  computed: {
    cCompany() {
      if (this.form.payType) {
        const payType = this.form.payType.split('-')[1]
        const shipperCode = this.form.payType.split('-')[0]
        const sCom = this.companys.find(el => el.shipperCode === shipperCode)
        return sCom
      }
      return null
    }
  },
  watch: {
    'orderType'(n) {
      this.form.payType = ''
      console.log('nnnnnnnnnnnnnnnnnnnn', n)
      this.getFreight()
      // this.getCompanyList()
    },
    'form.payType'() {
      if (this.cCompany) {
        this.getCoupon(this.cCompany.shipperCode, 1)
      }
      this.$refs.form.validateField('payType')
    },
    'form.pickTime'() {
      this.$refs.form.validateField('pickTime')
    },
    'form.saddr'(n) {
      this.getFreight()
    },
    'form.raddr'(n) {
      this.getFreight()
    },
    'form.weight'(n) {
      this.getFreight()
    },
    'form.pickDay'(n) {
      if (n) {
        this.onDayChange(n)
      } else {
        this.form.pickTime = ''
      }
    },
    gIndex(n) {
      this.form.cargos = [this.goods[n]]
      this.$refs.form.validateField('cargos')
    }
  },
  async created() {
    // 组件创建时，这个函数就会被触发
    const staff = await this.$http(this.$api.staffGet)
    this.depname = staff && staff.departmentname
    this.getFreight()
    this.getDefaultAddr()
    this.getTimeOpt()
    // this.form.orderType = this.orderType
    // const list = await this.$http(this.$api.departmentGetDepartmentList)
    // this.departmentList = list
  },
  // 例如：企小哥，13800000000，广东省深圳市福田区某某街道某某大厦001号
  mounted() {

  },
  methods: {
    async setMonthCode() {
      // 需要一个设置id
      const sCom = this.getScom()
      if (!sCom) {
        return
      }
      const res = await this.$http({ ...this.$api.logisticsSetExpress, origin: true }, {
        'id': sCom.id,
        'monthcode': this.mcode,
        'shippercode': sCom.shipperCode
      })
      if (res.data.state === 'success') {
        this.getFreight()

        this.showMonthCode = false
        this.$message.success('设置成功')
      } else {
        this.$message.error(res.data.msg)
      }
    },
    getTimeOpt() {
      this.$http(this.$api.orderGetInitPickupDayTimeSlot, {}).then(async(res) => {
        if (res) {
          this.dayOpts = res.selectTerm
          this.form.pickDay = res.defaultDayCode
          this.defPickTime = res.defaultTimeCode
        }
      })
    },
    async getDefaultAddr() {
      const res = await this.$http(this.$api.orderGetDefaultSenderAddress)
      if (res.areaCode) {
        // this.form.saddr = res
        this.recType = 1
        this.resumeInfo(res)
      }
    },

    async getCompanyList() {
      const res = await this.$http(this.$api.logisticsGetUsableList, {
        orderType: this.form.orderType,
        status: 1
      })
      this.companys = res || []
      this.sIndex = ''
    },
    async getCoupon(shipperCode, num) {
      const res = await this.$http(this.$api.couponGetCoupon, {
        shipperCode: shipperCode,
        'orderCount': num
      })
      this.coupon = res
    },
    async getPayType(id, orderType) {
      const res = await this.$http(this.$api.logisticsGetUsableOne, {
        id,
        orderType: this.form.orderType
      })
      this.payTypes = res
    },
    resumeInfo(res) {
      if (this.recType === 1) {
        this.form.sname = res.contactName
        this.form.sphone = res.mobile
        this.form.scompany = res.companyName
        this.form.saddr = {
          provinceName: res.provinceName,
          provinceCode: res.provinceCode,
          cityName: res.cityName,
          cityCode: res.cityCode,
          areaName: res.areaName,
          areaCode: res.areaCode,
          addressDetail: res.addressDetail

        }
      } else {
        this.form.rname = res.contactName
        this.form.rphone = res.mobile
        this.form.rcompany = res.companyName
        this.form.raddr = {
          provinceName: res.provinceName,
          provinceCode: res.provinceCode,
          cityName: res.cityName,
          cityCode: res.cityCode,
          areaName: res.areaName,
          areaCode: res.areaCode,
          addressDetail: res.addressDetail
        }
      }
    },
    async getAddrInfo() {
      if (!this.addrInfo) {
        this.$message.warning('请输入内容')
        return
      }
      const res = await this.$http(this.$api.addressRecognizeAddress, {
        inputContent: this.addrInfo
      })
      if (res) {
        this.resumeInfo(res)
        this.visible = false
      }
    },
    getAddr2() {
      this.recType = 2
      this.visible = true
    },
    getAddr1() {
      this.recType = 1
      this.visible = true
    },
    async onDayChange(val) {
      const res = await this.$http(this.$api.orderGetPickupTimeSlot, {
        shortDay: val
      })
      this.timeOpts = res
      if (this.defPickTime) {
        this.form.pickTime = this.defPickTime
        this.defPickTime = ''
      } else {
        this.form.pickTime = ''
      }
    },
    // async getTimeOpt(shipperCode) {
    //   const res = await this.$http(this.$api.orderGetPickupTimeSlot, {})
    //   this.dayOpts = res
    //   this.timeOpts = []
    // },
    async getFreight() {
      // 做几个事情
      // 多个收件人的运费要穿数组
      // 默认选中
      console.log()
      const params = { orderType: this.orderType }
      if (this.form.saddr && this.form.raddr && this.form.weight) {
        Object.assign(params, {
          'fromCity': this.form.saddr.cityName,
          'fromProvice': this.form.saddr.provinceName,
          receviers: [{
            'cityName': this.form.raddr.cityName,
            'provinceName': this.form.raddr.provinceName,
            'weight': this.form.weight || 1
          }]
        })
      }
      const res = await this.$http(this.$api.logisticsGetPcSelectableShipperList, params)
      this.companys = res
      const c = this.companys.find(el => el.lastOrderPayType)
      this.form.payType ? '' : this.form.payType = c.shipperCode + '-' + c.lastOrderPayType
      console.log('this.form.payType', this.form.payType)
    },
    // TODO:到时候清理
    async _getFreight() {
      if (this.form.saddr && this.form.raddr && this.form.shipperCode && this.form.weight) {
        const res = await this.$http(this.$api.logisticsGetEstimateTimePrice, {
          'pickUpTime': this.form.pickTime,
          'fromCity': this.form.saddr.cityName,
          'fromProvice': this.form.saddr.provinceName,
          'shipperCode': this.form.shipperCode,
          'toCity': this.form.raddr.cityName,
          'toProvice': this.form.raddr.provinceName,
          'weight': this.form.weight
        })
        this.estimateTimePrice = res
      } else {
        this.estimateTimePrice = null
      }
    },
    checkFreight() {
      // sessionStorage.setItem('waybill-query',this.form)
      this.$router.push('/main/send/waybill-query')
    },
    getScom() {
      const payType = this.form.payType.split('-')[1]
      const shipperCode = this.form.payType.split('-')[0]
      const sCom = this.companys.find(el => el.shipperCode === shipperCode)
      return sCom
    },
    setCoding() {
      const sCom = this.getScom()
      const payType = this.form.payType.split('-')[1]
      if (+payType === 3 && !sCom.monthcode) {
        if (this.$store.state.user.isAdmin) {
          this.showMonthCode = true
        } else {
          this.$message.warning('请联系管理员设置月结账号')
        }
        return true
      } else {
        return false
      }
    },
    // methods这个对象，存放的是template标签里面使用的方法
    post() {
      if (this.setCoding()) {
        return
      }
      this.$refs.form.validate(async valid => {
        console.log(valid)
        if (valid) {
          try {
            this.loading = true
            const payType = this.form.payType.split('-')[1]
            const res = await this.$http(this.$api.orderAdd, {
              'orderOrigin': 2,
              isUseCoupon: +payType === 5 && this.coupon && this.coupon.usableAmount > 0 ? 1 : '',
              'cargos': this.form.cargos,
              'freight': 1,
              'payType': payType,
              orderType: this.orderType,
              monthCode: this.cCompany ? this.cCompany.monthcode : '',
              'pickupEndTime': this.form.pickTime.split('~')[1],
              'pickupStartTime': this.form.pickTime.split('~')[0],
              'recevier': {
                'address': this.form.raddr.addressDetail,
                'areaCode': this.form.raddr.areaCode,
                'areaName': this.form.raddr.areaName,
                'cityCode': this.form.raddr.cityCode,
                'cityName': this.form.raddr.cityName,
                'companyName': this.form.rcompany,
                'mobile': this.form.rphone,
                'name': this.form.rname,
                'provinceCode': this.form.raddr.provinceCode,
                'provinceName': this.form.raddr.provinceName,
                'tel': this.form.rtelephone
              },
              'remark': this.form.remark,
              'sender': {
                isSaveAddr: this.isSetDefaultAddr ? 1 : 0,
                'address': this.form.saddr.addressDetail,
                'areaCode': this.form.saddr.areaCode,
                'areaName': this.form.saddr.areaName,
                'cityCode': this.form.saddr.cityCode,
                'cityName': this.form.saddr.cityName,
                'companyName': this.form.scompany,
                'mobile': this.form.sphone,
                'name': this.form.sname,
                'provinceCode': this.form.saddr.provinceCode,
                'provinceName': this.form.saddr.provinceName,
                'tel': this.form.stelephone
              },
              'shipperCode': this.form.payType.split('-')[0],
              'weight': this.form.weight
            })
            this.loading = false
            if (res) {
              this.$router.push('/main/search/success?kdnOrderCode=' + res.kdnOrderCode)
            }
          } catch (error) {
            this.loading = false
          }
        }
      })
    },
    setInfo(info) {

    },
    range(start, end) {
      const result = []
      for (let i = start; i < end; i++) {
        result.push(i)
      }
      return result
    },
    disabledDate(current) {
      return current < moment().startOf('day') || current > moment().startOf('day').add(3, 'd').endOf('day')
    },
    disabledDateTime() {
      return {
        disabledHours: () => {
          // 如果
          this.range(0, 24).splice(20, 24).concat(this.range(0, 24).splice(0, moment().hour()))
        },
        disabledMinutes: () => this.range(0, 60),
        disabledSeconds: () => this.range(0, 60)
      }
    },
    ok1(info) {
      this.form.sname = info.contactName
      this.form.sphone = info.mobile
      this.form.stelephone = info.phone
      this.form.saddr = info
      this.form.scompany = info.companyName
      this.$nextTick(() => {
        this.$refs.form.validateField('sphone')
        this.$refs.form.validateField('saddr')
        this.$refs.form.validateField('sname')
        this.$refs.form.validateField('scompany')
      })
    },
    ok2(info) {
      this.form.rname = info.contactName
      this.form.rphone = info.mobile
      this.form.rtelephone = info.phone
      this.form.raddr = info
      this.form.rcompany = info.companyName
      this.$nextTick(() => {
        this.$refs.form.validateField('rphone')
        this.$refs.form.validateField('raddr')
        this.$refs.form.validateField('rname')
        this.$refs.form.validateField('rcompany')
      })
    }
  }
}
</script>

<style lang="scss" >
.send-page {
  .shipperSelect{
    .ant-form-item-control-wrapper{
      width: 100%;
    }
    .ant-table-tbody > tr > td{
      padding: 10px;
    }
  }
  .ant-cascader-input{
    width: 280px;
  }
  .v-line{
    // width: 1px ;
    margin-top: 16px;
    margin-bottom: 16px;
    height: 1px;
    background: rgba(212, 212, 212, 1);
    // margin-right: 80px;
  }
  .flex2{
    flex: 2;
  }
  .bg-blue1{
    background: rgba(240, 245, 255, 1);
  }
  .goods{
    border: 1px solid rgba(0,0,0,0.15);
    line-height: 32px;
    text-align: center;
    height: 32px;
    padding: 0 16px 0 16px;
    cursor: pointer;
  }
  .company{
    border: 1px solid rgba(0,0,0,0.15);
    border-radius:2px;
    width: 116px;
    height: 42px;
    text-align: center;
    cursor: pointer;
  }
  .c-active{
    border: 1px solid rgb(24, 144, 255);
    position: relative;
    &::after{
      content: '';
      background-image: url('~@/assets/send/check@2x.png');
      background-repeat: no-repeat;
          height: 18px;
    width: 18px;
    bottom: 0;
    right: 0;
    position: absolute;
    background-position: center;
    background-size: contain;;
    }
  }
  .my-form-item{
    margin-right: 0;
    margin-bottom: 0;
    // width: 100%;
    display: flex;
    .ant-form-item-control-wrapper{
      // flex: 1;
    }
    [for=order_post_rphone] ,[for=order_post_sphone],[for=order_post_scompany],[for=order_post_rcompany],[for=order_post_stelephone],[for=order_post_rtelephone]{
      padding-left: 20px;
    }
  }
  .my-pl-20{
    .ant-form-item-label{
          padding-left: 20px;
    }
  }
  .my-pl-60{
    .ant-form-item-label{
          padding-left: 60px;
    }
  }
  .my-pl-10{
    .ant-form-item-label{
      padding-left: 10px;
    }
  }
  .my-pl-31{
    .ant-form-item-label{
          padding-left: 31px;
    }
  }
  .addr{
    .ant-cascader-picker{
      width:280px
    }
    .ant-input{
      width:380px
    }
  }
}
</style>
